import React, { Component } from 'react';
import _ from 'underscore';
import { withPerfMarker } from '@bingads-webui/performance-marker-react-wrapper';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import ReportingProps from '@bingads-webui-campaign-react/props-reporting';
import { EmailPicker } from '@bingads-webui-campaign/reports-v4-email-picker';
import PropTypes from 'prop-types';
import { Checkbox } from '@bingads-webui-react/primitive';
import { Frequency } from './frequency';
import { StartEndDate } from './start-end-date';
import { FileFormatSelector } from './FileFormatSelector';

class ReportSchedule extends Component {
  onUpdateEmailRecipients = (newEmailRecipients) => {
    this.props.setSchedule({ EmailRecipients: newEmailRecipients });
  };

  changeHour = (hour) => {
    const Cron = this.props.cronFormatter.toCronString(_.defaults({ hour }, this.CronModel));
    this.props.setSchedule({ Cron });
  };

  changeStartEndDate = (date) => {
    this.props.setSchedule(date);
  };

  changeFileFormat = (fileFormat) => {
    this.props.setSchedule({ Format: fileFormat });
  };

  changeFrequency = ({ frequency, dayOfWeek, dayOfMonth }) => {
    const Cron = this.props.cronFormatter.toCronString({
      frequency,
      dayOfWeek,
      dayOfMonth,
      hour: this.CronModel.hour,
    });
    this.props.setSchedule({ Cron });
  };

  render() {
    const {
      isScheduleEnabled,
      i18n, cronFormatter, classes,
      StartDate, EndDate, setSchedule,
      AttachFileToEmail, Cron,
      EmailRecipients, Template, FileFormat,
    } = this.props;

    this.CronModel = cronFormatter.parse(Cron);

    return (
      <div id="reportSchedule" className={classes.reportSchedule}>
        <React.Fragment>
          <div className={classes.scheduleTime}>
            <Frequency
              isScheduleEnabled={isScheduleEnabled}
              classes={classes}
              i18n={i18n}
              cronFormatter={cronFormatter}
              CronModel={this.CronModel}
              changeDefaultFrequency={this.changeDefaultFrequency}
              changeFrequency={this.changeFrequency}
              changeHour={this.changeHour}
            />
            <StartEndDate
              isScheduleEnabled={isScheduleEnabled}
              classes={classes}
              i18n={i18n}
              startDate={StartDate}
              endDate={EndDate}
              changeStartEndDate={this.changeStartEndDate}
            />
          </div>
          <div className={classes.emailTextArea}>
            <div className={classes.emailTitle} id="sendToLabel">{i18n.getString(_TL_('Send report to'))}</div>
            <EmailPicker
              isScheduleEnabled={isScheduleEnabled}
              emails={EmailRecipients}
              onChange={this.onUpdateEmailRecipients}
              i18n={i18n}
            />
          </div>
          <div className={classes.fileFormat}>
            <FileFormatSelector
              isScheduleEnabled={isScheduleEnabled}
              classes={classes}
              i18n={i18n}
              changeFileFormat={this.changeFileFormat}
              fileFormat={FileFormat}
              Template={Template}
            />
          </div>
          <div className={classes.includeAttachment}>
            <Checkbox
              disabled={!isScheduleEnabled}
              id="includeAttachmentCheckbox"
              onChange={val => setSchedule({ AttachFileToEmail: val.target.checked })}
              checked={AttachFileToEmail}
            >
              {i18n.getString(_TL_('Include report as an email attachment'))}
              {
                AttachFileToEmail &&
                <div className={classes.attachmentTooLarge} id="attachmentTooLargeMessage">
                  {i18n.getString(_TL_('Reports larger than 4MB will not be included as email attachments.'))}
                </div>
              }
            </Checkbox>
          </div>
        </React.Fragment>
      </div>
    );
  }
}

/* eslint-disable react/no-typos */
ReportSchedule.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  i18n: ReportingProps.i18n.isRequired,
  isScheduleEnabled: PropTypes.bool.isRequired,
  Cron: PropTypes.string.isRequired,
  EmailRecipients: PropTypes.arrayOf(PropTypes.string).isRequired,
  StartDate: PropTypes.string.isRequired,
  EndDate: PropTypes.string.isRequired,
  setSchedule: PropTypes.func.isRequired,
  cronFormatter: PropTypes.object.isRequired, // eslint-disable-line
  AttachFileToEmail: PropTypes.bool.isRequired,
  Template: PropTypes.string.isRequired,
  FileFormat: PropTypes.string.isRequired,
};

function getStyle(components, { palette }) {
  return {
    reportSchedule: {
      paddingTop: '40px',
      paddingLeft: '0',
      maxWidth: 'none',
      '& select': {
        minWidth: 0,
        display: 'inline-block',
        marginRight: '5px',
        width: '135px',
      },
    },
    scheduleTime: {
      display: 'flex',
      alignItems: 'center',
      '& > div': {
        position: 'relative',
      },
      '& > div:not(:last-child)': {
        marginRight: '10px',
      },
    },
    fileFormat: {

    },
    emailTextArea: {
      width: '500px',
      marginTop: '22px',
      '& > div:first-child': {
        top: '-8px',
        position: 'relative',
      },
      '& .error': {
        color: '#A80000',
      },
      '& textarea': {
        maxWidth: '100%',
      },
    },
    emailTitle: {
      position: 'absolute',
      top: '-24px',
      color: `${palette.neutralPrimary}`,
      fontWeight: '500',
    },
    attachmentTooLarge: {
      paddingTop: '2px',
      color: '#999',
      font: 'normal 10px arial !important',
    },
    includeAttachment: {
      marginTop: '8px',
      marginBottom: '8px',
    },
  };
}

const Wrapped = withDefaultStyles(withPerfMarker(ReportSchedule, { name: 'reporting-schedule' }), getStyle);

export { Wrapped as ReportSchedule };

